import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';

export type LangCode = string;

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly STORAGE_KEY = 'lang';
  private readonly translate = inject(TranslateService);
  private readonly dateAdapter = inject(DateAdapter<Date>);

  private supported = new Set<string>();
  private initialized = false;
  private defaultLang = 'en';

  init(opts: { supported: readonly string[]; defaultLang?: string }): void {
    // merge (poți chema init din mai multe locuri)
    for (const l of opts.supported) this.supported.add(l);
    this.defaultLang = opts.defaultLang ?? this.defaultLang;

    this.translate.addLangs([...this.supported]);
    this.translate.setFallbackLang(this.defaultLang);

    const saved = this.getSavedLang();
    const lang = (saved && this.supported.has(saved)) ? saved : this.defaultLang;

    this.translate.use(lang);
    this.dateAdapter.setLocale(this.toMatLocale(lang));

    this.initialized = true;
  }

  getCurrent(): string {
    return this.translate.currentLang || this.defaultLang;
  }

  getSupported(): string[] {
    return [...this.supported];
  }

  set(lang: string): void {
    // dacă nu e în supported, fallback
    const useLang = this.supported.has(lang) ? lang : this.defaultLang;

    localStorage.setItem(this.STORAGE_KEY, useLang);
    this.translate.use(useLang);
    this.dateAdapter.setLocale(this.toMatLocale(useLang));
  }

  private getSavedLang(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  private toMatLocale(lang: string): string {
    // suportă en-US, ro-RO, etc. + fallback ok
    if (lang === 'ro') return 'ro-RO';
    if (lang === 'en') return 'en-US';
    return lang; // dacă tu salvezi direct 'en-GB', 'de-DE', etc.
  }
}
